// Keep the version in sync with the consent checks in firestore.rules.
// Increment the version when the community code changes and must be accepted again.
export const COMMUNITY_CONDUCT_VERSION = '1';
export const COMMUNITY_CONDUCT_URL = 'https://convivialapp.it/codice-condotta/';
